import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
const outcomes = ['Él responde rápido… incluso cuando está ocupado', 'Es él quien inicia conversaciones', "Te escribe '¿Qué haces?' sin motivo", 'Se interesa genuinamente por ti', 'Busca verte… insiste… invierte'];
export function DreamOutcome() {
  return <section className="py-14 px-6 bg-[#161616] relative" data-id="element-56">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10 items-center" data-id="element-57">
        <div data-id="element-58">
          <FadeIn data-id="element-59">
            <h2 className="font-serif text-4xl md:text-5xl font-bold mb-6" data-id="element-60">
              Imagina <span className="text-brand-rose italic" data-id="element-61">esto...</span>
            </h2>
          </FadeIn>

          <div className="space-y-4" data-id="element-62">
            {outcomes.map((outcome, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-63">
                <div className="flex items-start gap-3" data-id="element-64">
                  <CheckCircle2 className="w-5 h-5 text-brand-rose shrink-0 mt-1" data-id="element-65" />
                  <p className="text-lg text-brand-cream" data-id="element-66">{outcome}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.6} data-id="element-67">
            <div className="mt-8 p-5 bg-brand-rose/10 border border-brand-rose/20 rounded-2xl" data-id="element-68">
              <p className="text-lg font-serif italic text-brand-cream" data-id="element-69">
                "Convertirte en la mujer que no persigue… sino la que hace que
                la persigan."
              </p>
            </div>
          </FadeIn>
        </div>

        <div className="relative" data-id="element-70">
          <FadeIn direction="right" data-id="element-71">
            <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-[#0a0a0a] p-6 shadow-2xl" data-id="element-72">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-rose to-rose-400" data-id="element-73" />

              <div className="space-y-4" data-id="element-74">
                {/* Mock Chat Messages */}
                <div className="flex flex-col gap-3" data-id="element-75">
                  <div className="self-end bg-brand-rose text-white px-4 py-3 rounded-2xl rounded-tr-sm max-w-[80%] text-sm" data-id="element-76">
                    Ayer la pasé increíble ✨
                  </div>

                  <div className="self-start bg-brand-gray text-brand-cream px-4 py-3 rounded-2xl rounded-tl-sm max-w-[80%] text-sm opacity-50" data-id="element-77">
                    Visto 10:42 AM
                  </div>
                </div>

                <div className="w-full h-px bg-white/10 my-4 relative" data-id="element-78">
                  <span className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#0a0a0a] px-4 text-xs text-brand-lightGray uppercase tracking-widest" data-id="element-79">
                    El Cambio
                  </span>
                </div>

                <div className="flex flex-col gap-3" data-id="element-80">
                  <div className="self-start bg-brand-gray text-brand-cream px-4 py-3 rounded-2xl rounded-tl-sm max-w-[80%] text-sm shadow-lg border border-white/5" data-id="element-81">
                    Hey, no dejo de pensar en lo de ayer. ¿Cuándo te vuelvo a
                    ver? 👀
                  </div>
                  <div className="self-start bg-brand-gray text-brand-cream px-4 py-3 rounded-2xl rounded-tl-sm max-w-[80%] text-sm shadow-lg border border-white/5" data-id="element-82">
                    ¿Estás muy ocupada hoy?
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}